<script lang="ts" setup>
const emit = defineEmits(["continue", "back"]);
const userStore = useUserStore();

type State = "start" | "input" | "success";
const state = ref<State>("start");
const isLoading = ref(false);
const phrase = ref("");
const inputPhrase = ref("");
const error = ref(false);

const handleContinue = async () => {
  if (await isRecoveryKeyCorrect()) {
    state.value = "success";
    isLoading.value = true;
    emit("continue", {
      method: "recoveryPassword",
      value: phrase.value,
    });
  } else {
    error.value = true;
  }
};

const isRecoveryKeyCorrect = async () => {
  try {
    if (userStore.keys?.recoveryPassword?.value) {
      const privateKey = await decrypt(
        userStore.keys?.recoveryPassword.value,
        inputPhrase.value
      );
      useWeb3().setPrivateKey(privateKey);
      return true;
    } else {
      throw new Error("No recovery key found");
    }
  } catch (error: any) {
    return false;
  }
};
</script>

<template>
  <div>
    <div class="flex gap-2 font-bold flex-wrap">
      <h3 class="text-neutral-200">
        {{ $t("main.walletLock.unlockWalletWithRecoveryKit") }}
      </h3>
    </div>
    <div class="text-neutral-300 flex flex-col gap-4">
      <p class="mt-4">
        {{ $t("main.walletLock.recoveryKeyCanBeFoundInTheRecoveryKit") }}
      </p>
      <form @submit.prevent="handleContinue">
        <BaseInputPassword
          v-model="inputPhrase"
          :label="$t('main.modalUserWalletCreate.yourRecoveryKey')"
          :placeholder="
            $t('main.modalUserWalletCreate.recoveryPasswordPlaceholder')
          "
          :id="'recovery-password'" />
        <p v-if="error" class="text-red-500">
          {{ $t("Incorrect recovery key") }}
        </p>
        <div class="w-full flex gap-4 py-4">
          <BaseButtonCancel
            :text="$t('main.modalUserWalletCreate.cancel')"
            size="lg"
            class="w-full"
            @click="emit('back')" />
          <BaseButtonSubmit
            :text="$t('main.modalUserWalletCreate.continue')"
            size="lg"
            class="w-full"
            @click="handleContinue" />
        </div>
      </form>
    </div>
  </div>
</template>
